var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;

  /* Concrete View */
  apptBook.LocationSelectSection = function (container) {
    apptBook.LocationSelectSection.superclass.constructor.call(this);
    this.id = 'counters';
    this.container = container;
    this.selectMenu = container.find('select.location-select');
    this.stateSelectMenu = container.find('select.state-select');
    this.locationSelectCont = container.find('.location-select-container');
    this.submitBtn = container.find('.location-submit');
    this.signinMessage = container.find('.appt-book-location__signin-text');
    this.boundTransIn = this.onTransIn.bind(this);
    this.initialized = false;
    this.disableStateDropDown = false;
    (this.stores = {}),
      (this.physicalOABInactive = container.find('.appt-book-location-selector').data('physical-oab-inactive'));
  };

  ctrlopt.extend(apptBook.LocationSelectSection, apptBook.AbstractSection);

  apptBook.LocationSelectSection.prototype.buildStateSelectMenu = function () {
    var me = this;

    if (!this.countersData || !this.stateSelectMenu.length) {
      return;
    }

    var uniqueStatesArray = [];

    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      var storeName = this.countersData[i].name;
      // If we have a state hash mapping from CMS, use that to turn the values from appt booking to
      // the displayable value we want, else just use the value directly from appt booking
      var county = this.countersData[i].county;

      if (apptBook.LocationSelectSection.prototype.useStateHash == '1') {
        county = this.countersData[i].county ? me.stateHash[this.countersData[i].county] : null;
      }

      var stateObj = this.countersData[i].state;
      var stateLongName = stateObj ? stateObj.long_name : county ? county : null;
      var stateShortName = stateObj ? stateObj.short_name : this.countersData[i].county;
      var optionText = stateLongName;
      var optionValue = stateShortName;
      var newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');

      if (!stateShortName || !stateLongName) {
        continue;
      }

      // Only populate state menu with unique state values
      if (uniqueStatesArray.indexOf(stateShortName) < 0) {
        // Don't filter out counters
        this.stateSelectMenu.append(newOption);
        uniqueStatesArray.push(stateShortName);
      }
    }
    sortLocationOptions();

    function sortLocationOptions() {
      var foption = $(me.stateSelectMenu).find('option:first');

      $(me.stateSelectMenu).html(
        $(me.stateSelectMenu)
          .find("option:not(':first-child')")
          .sort(function (a, b) {
            return a.text.toUpperCase() > b.text.toUpperCase()
              ? 1
              : a.text.toUpperCase() < b.text.toUpperCase()
              ? -1
              : 0;
          })
      );
      $(me.stateSelectMenu).prepend(foption);
    }

    this.stateSelectMenu.on('change', $.proxy(me.onStateMenuChange, this));
  };

  apptBook.LocationSelectSection.prototype.onStateMenuChange = function (menu) {
    var me = this;
    var menuVal = menu.target.value;

    if (menuVal !== '0') {
      me.selectMenu.removeClass('disabled');
      me.selectMenu.removeAttr('disabled');
      me.selectMenu.find('option[value!="0"]').remove();
      me.buildCounterSelectMenu(menu.target.value);
    } else {
      me.selectMenu.val('0');
      me.selectMenu.addClass('disabled');
      me.selectMenu.attr('disabled', '');
    }

    me.resetSelect(me.locationSelectCont);
  };

  apptBook.LocationSelectSection.prototype.buildCounterSelectMenu = function (filter) {
    var me = this;

    if (!this.countersData || !this.selectMenu.length) {
      return;
    }

    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      var storeName = me.countersData[i].name;
      var stateObj = me.countersData[i].state;
      var state = stateObj ? stateObj.short_name : me.countersData[i].county;
      var optionText =
        storeName +
        ' - ' +
        me.countersData[i].town +
        ', ' +
        state +
        ', ' +
        me.countersData[i].address1 +
        ' ' +
        me.countersData[i].postcode;
      var optionValue = me.countersData[i].id;
      var newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');
      var storeNum = me.countersData[i].store_no;
      var maxApptDuration = me.countersData[i].max_appointment_duration;
      var maxApptServices = me.countersData[i].max_appointment_services;
      var tSlotInt = me.countersData[i].timeslot_interval;

      if (filter && filter != state) {
        continue;
      }

      this.stores[optionValue] = {
        store: storeNum,
        name: storeName,
        maxApptDuration: maxApptDuration,
        maxApptServices: maxApptServices,
        tSlotInt: tSlotInt
      };

      // Don't filter out counters
      this.selectMenu.append(newOption);
    }
    sortLocationOptions();

    function sortLocationOptions() {
      var foption = $(me.selectMenu).find('option:first');

      $(me.selectMenu).html(
        $(me.selectMenu)
          .find("option:not(':first-child')")
          .sort(function (a, b) {
            return a.text.toUpperCase() > b.text.toUpperCase()
              ? 1
              : a.text.toUpperCase() < b.text.toUpperCase()
              ? -1
              : 0;
          })
      );
      $(me.selectMenu).prepend(foption);
    }

    function setSubmitBtnState() {
      if (me.selectMenu.val() === '0') {
        me.submitBtn.addClass('disabled');
      } else {
        me.submitBtn.removeClass('disabled');
      }

      return;
    }

    setSubmitBtnState();
    this.selectMenu.on('change', setSubmitBtnState);
  };

  apptBook.LocationSelectSection.prototype.setSubmitHandler = function () {
    var me = this;

    function onSubmit(e) {
      var updateData,
        select = me.selectMenu[0],
        counterId = select.options[select.selectedIndex].value;

      e.preventDefault();

      if ($(this).hasClass('disabled')) {
        return;
      }

      if (counterId) {
        site?.track?.evtLink && site.track.evtLink({
          event_name: 'appointmentBooking_Location',
          event_category: 'appointment booking',
          event_action: 'location chosen',
          event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
        });

        updateData = {
          sectionId: 'next',
          params: {
            sectionId: me.id,
            counterId: counterId,
            maxApptDuration: me.stores[counterId].maxApptDuration,
            maxApptServices: me.stores[counterId].maxApptServices,
            timeSlotInterval: me.stores[counterId].tSlotInt,
            updateMode: me.updateMode
          }
        };
        me.model.update(updateData);
      }
    }

    this.submitBtn.click(onSubmit);
  };

  apptBook.LocationSelectSection.prototype.onTransIn = function () {
    this.container.find('.selectbox').each(function () {
      $(this).trigger('select.enabled');
    });
  };

  apptBook.LocationSelectSection.prototype.resetSelect = function ($node) {
    var $container = $node || this.container;

    $container.find('div.selectbox').remove();
    $container.find('select.selectbox').each(function () {
      $(this).removeClass('select-box--replaced js-select-box-replaced');
      if ($(this).hasClass('disabled')) {
        $(this).trigger('select.disabled');
      } else {
        $(this).trigger('select.enabled');
      }
    });
  };

  apptBook.LocationSelectSection.prototype.onUpdate = function (data) {
    var me = this;
    var aPgName = document.title + ' - Location Select';
    var config = Drupal.settings.appointment_booking_main_collection;

    if (data.sectionId === this.id) {
      apptBook.sectionManager.on('transition_in_start', this.boundTransIn);

      me.isSignedIn =
        typeof site.userInfoCookie == 'undefined' ||
        _.isUndefined(site.userInfoCookie.getValue('signed_in')) ||
        _.isNull(site.userInfoCookie.getValue('signed_in'))
          ? 0
          : site.userInfoCookie.getValue('signed_in');

      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }
      if (!this.initialized) {
        this.initialized = true;

        this.model.getCounters(function (cData) {
          var virtualList = [],
            virtualIds;

          // Wait for geoloc data to load before proceeding if enabled.
          if (config.geo_location_enable) {
            $(document).on(
              'geoloc_data',
              $.proxy(function () {
                me.countersData = apptBook.geoLoc.mergeGeoLocWithCounters(cData);
                me.buildStateSelectMenu();
                me.resetSelect();
              }, this)
            );
          } else if (this.disableStateDropDown) {
            me.countersData = cData;
            me.buildCounterSelectMenu();
            me.resetSelect();
          } else {
            me.countersData = [];
            for (var j = 0; j < me.model.servicesData.length; j += 1) {
              if (me.model.servicesData[j].virtual !== '0') {
                virtualList.push(me.model.servicesData[j].id);
              }
            }
            for (var i = 0; i < cData.length; i++) {
              virtualIds = virtualList.filter(function (e) {
                return cData[i].service_ids.indexOf(e) !== -1;
              });
              if (!virtualIds.length) {
                me.countersData.push(cData[i]);
              }
            }
            me.buildStateSelectMenu();
            me.resetSelect();
          }
          if (me.isSignedIn > 0) {
            me.signinMessage.hide();
          }
          me.setSubmitHandler();
        });
      }
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundTransIn);
    }
  };

  Drupal.behaviors.apptBookLocation = {
    attach: function (context) {
      var view = new apptBook.LocationSelectSection($('#counters')),
        self = this;

      self.setVirtual('virtual_oab', 0);
      view.setModel(apptBook.sectionModel).startObserving();
      $('.js-virtual__appointment--btn').on('click', function () {
        site?.track?.evtLink && site.track.evtLink({
          event_name: 'appointmentbooking',
          event_category: 'appointment booking',
          event_action: 'start',
          event_label: 'video appointment'
        });
        var storeNumber = $('.appt-book-location-selector').attr('data-virtual_store_querystring_value');

        self.setVirtual('virtual_oab', 1);
        apptBook.jumpToServicesForStore(storeNumber);
      });
    },
    setVirtual: function (key, value) {
      localStorage.setItem(key, value);
    }
  };
})(jQuery);
